/** Redux utilities for data sanitization and transformation. */

import { formatISO } from 'date-fns';

/** Recursively removes undefined values before Firestore writes. Used when saving Google Places data. */
export const deepCleanObject = <T>(obj: T): T => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => deepCleanObject(item)) as T;
  }

  if (typeof obj === 'object') {
    const cleaned: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== undefined) {
        cleaned[key] = deepCleanObject(value);
      }
    }
    return cleaned as T;
  }

  return obj;
};

/** Formats a Date to ISO string (YYYY-MM-DD). Used for trip date storage. */
export const getISODate = (date: Date) => formatISO(date, { representation: 'date' });

/** Returns elements common to both sets. Used when deleting a list to find itinerary events to remove. */
export const getIntersection = <T>(setA: Set<T>, setB: Set<T>): Set<T> =>
  new Set(Array.from(setA).filter((x) => setB.has(x)));
